import { render, staticRenderFns } from "./TemplateDetail.vue?vue&type=template&id=7372d76a&scoped=true"
import script from "./TemplateDetail.vue?vue&type=script&lang=ts"
export * from "./TemplateDetail.vue?vue&type=script&lang=ts"
import style0 from "./TemplateDetail.vue?vue&type=style&index=0&id=7372d76a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7372d76a",
  null
  
)

export default component.exports